<template>
  <a class="accessibility" href="#main">Skip to Content</a>
  <noscript>
    <div>Javascript must be enabled for the correct page display</div>
  </noscript>
  <div class="wrapper">
    <header class="header" id="header">
      <div class="container container-sm">
        <div class="logo-login">
          <a href="#"
            ><img
              src="/images/logo-light.svg"
              width="294"
              height="145"
              alt="Audioscribe"
          /></a>
        </div>
      </div>
    </header>
    <div class="page-holder">
      <main class="main" id="main">
        <section class="login-section">
          <span class="login_decor"
            ><img
              src="/images/logo-decor.svg"
              width="1162"
              height="1162"
              alt="Image Description"
          /></span>
          <div class="container container-sm">
            <h1>Redirecting to Stripe</h1>
            <div class="text-holder text-center">
              <!-- Show loading or success message while redirecting -->
              <p v-if="!errorMessage">
                Redirecting to Stripe with discount code {{ promoCode }}
              </p>

              <!-- Show error message if the checkout session creation fails -->
              <p v-else>{{ errorMessage }}</p>
            </div>
          </div>
        </section>
      </main>
    </div>
    <footer class="footer" id="footer">
      <!-- footer content -->
    </footer>
  </div>
</template>

<script>
import { createCheckoutSession } from "@/services/workspace.service.js";
import { mapStores } from "pinia";
import { useWorkSpaceStore } from "@/stores/workspace-store";

export default {
  name: "SettingsStripeRedirect",
  data() {
    return {
      isYearly: false, // Assume monthly subscription
      promoCode: this.$route.params.promoCode, // Capture promo code from the URL
      errorMessage: null, // Track error message if checkout session creation fails
      torndown: false, // Set on unmount so late async continuations never navigate
    };
  },
  computed: {
    ...mapStores(useWorkSpaceStore),
  },
  methods: {
    async redirectToCheckout() {
      try {
        // Create checkout session with promo code and monthly billing. The
        // API helper resolves HTTP failures as { error } rather than
        // throwing; without a link the page would sit on "Redirecting".
        const { data, error } =
          (await createCheckoutSession("monthly", this.promoCode)) || {};
        if (this.torndown) return;
        if (error || !data?.stripeCheckoutSessionUrl) {
          throw new Error(error?.message || "No checkout URL");
        }
        globalThis.location.href = data.stripeCheckoutSessionUrl; // Redirect to the Stripe checkout page
      } catch (error) {
        console.error("Error creating Stripe checkout session", error);
        if (this.torndown) return;
        // Set the error message and schedule redirection to home page
        this.errorMessage =
          "Failed to create checkout link. Redirecting to the home page...";
        setTimeout(() => {
          if (!this.torndown) this.$router.push("/"); // Redirect to the home page after 3 seconds
        }, 3000);
      }
    },
  },
  async mounted() {
    // A promo link is only for people with no plan at all (this route is only
    // auth-guarded, so it's reachable by any signed-in user). Anyone already
    // subscribed (on the web, in the App Store or Google Play, both, a plan
    // AudioScribe granted, or a source we don't know) goes to Plans instead:
    // a checkout would start a second subscription or double-charge them.
    // Always check afresh, since an earlier answer can predate a purchase
    // made in a mobile app, and FAIL CLOSED if the check fails.
    const resolved = await this.workspaceStore.fetchSubscriptionStatus();
    if (this.torndown) return;
    if (!resolved) {
      this.errorMessage =
        "We couldn't verify your subscription status. Redirecting to the home page...";
      setTimeout(() => {
        if (!this.torndown) this.$router.push("/");
      }, 3000);
      return;
    }
    if (this.workspaceStore.isSubscribedState !== false) {
      // Plans shows how to manage the plan they already have.
      this.$router.replace("/settings/plans");
      return;
    }
    this.redirectToCheckout();
  },
  beforeUnmount() {
    this.torndown = true;
  },
};
</script>

<style scoped>
p {
  text-align: center;
  font-size: 18px;
  color: #333;
}
</style>
